import styled from 'styled-components';

export const StyleCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 5px;
    padding: ${({ padding }) => (padding || '25px 20px 20px 20px')};
    background-color: #FFFFFF;
    box-shadow: ${({ boxShadow }) => (boxShadow || '0 3px 4px rgba(0, 0, 0, 0.2)')};
    flex: 1;
    
    .mr-md-2 {
      margin-right: 10px;
    }
    
    .ml-md-2 {
      margin-left: 10px;
    }
    
    .content-header {
      display: flex;
      align-items: center;
      
      img.icon {
        max-width: 25px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }
        
      h4 {
        font-family: Poppins-Medium, Heltica, Arial, sans-serif;
        color: #2B2932;
        vertical-align: middle;
        font-size: 1.4em;
        margin-bottom: 0;
        display: inline-block;
      }
    }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: #8E8E8E;
        font-size: 15px;
        text-align: center;
        margin: ${({ contentMargin }) => (contentMargin || '30px 0')};
    }
    
    .btn.btn-gearbox {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      width: 100%;
      padding: 10px 0;
      font-size: 1.4em;
      text-align: center;
      background-color: #FF003D;
      border-color: #FF003D;
      color: #FFFFFF;
      outline: none;
    }
`;
